import { Component } from "@angular/core";
import { FieldType } from "@kre-form/core";
import * as moment_ from "moment";
const moment = moment_;

@Component({
  selector: "kreform-field-ion-datetime",
  template: `
    <ng-container *ngIf="!!editor; else other">
      <ion-item detail="true">
        <ion-datetime
          [displayFormat]="format"
          [pickerFormat]="format"
          [formControl]="formControl"
          [ionKreFormAttributes]="field"
          doneText="确认"
          cancelText="取消"
          mode="ios"
          [min]="minDate"
          [max]="maxDate"
        ></ion-datetime>
      </ion-item>
    </ng-container>
    <ng-template #other>
      <div class="fieldtext">{{ getText }}</div>
    </ng-template>
  `,
})
export class KreFormFieldIonDatetime extends FieldType {
  get maxDate() {
    let time = this.to.maxDate
      ? moment(this.to.maxDate).format("YYYY-MM-DDTHH:mm")
      : "2050-12-31T23:59";
    time = time.split("T")[1] ? time : time + "T23:59";
    return time;
    // return this.to.maxDate;
  }

  get minDate() {
    let time = this.to.minDate
      ? moment(this.to.minDate).format("YYYY-MM-DDTHH:mm")
      : moment()
          .subtract(100, "years")
          .startOf("year")
          .format("YYYY-MM-DDTHH:mm");
    time = time.split("T")[1] ? time : time + "T00:00";
    return time;
    // return this.to.minDate;
  }

  get format() {
    let result = "YYYY/MM/DD HH:mm";
    if (this.to.type !== undefined && this.to.type !== null) {
      switch (this.to.type.toLowerCase()) {
        case "datetime":
          break;
        case "date":
          result = "YYYY/MM/DD";
          break;
        case "year":
          result = "YYYY";
          break;
        case "month":
          result = "YYYY/MM";
          break;
        case "time":
          result = "HH:mm";
          break;
        default:
          break;
      }
    }
    return result;
  }

  get getText() {
    let result = "";
    if (
      this.to.type === undefined ||
      this.to.type === null ||
      this.to.type === ""
    ) {
      this.to.type = "datetime";
    }

    if (
      this.model != undefined &&
      this.model != null &&
      this.field != undefined &&
      this.field != null &&
      this.field.key != undefined &&
      this.field.key != null &&
      this.model[this.field.key] != undefined &&
      this.model[this.field.key] != null &&
      this.model[this.field.key] != ""
    ) {
      if (moment(this.model[this.field.key]).isValid()) {
        switch (this.to.type) {
          case "datetime":
            result = moment(this.model[this.field.key]).format(
              "YYYY/MM/DD HH:mm"
            );
            break;
          case "date":
            result = moment(this.model[this.field.key]).format("YYYY/MM/DD");
            break;
          case "year":
            result = moment(this.model[this.field.key]).format("YYYY");
            break;
          case "month":
            result = moment(this.model[this.field.key]).format("YYYY/MM");
            break;
          case "time":
            result = moment(this.model[this.field.key]).format("HH:mm");
            break;
        }
      }
    }

    return result;
  }
}
